// 利用規約
export const TERMS_URL: string = 'https://gigbase.jp/terms'

// プライバシーポリシー
export const PRIVACY_POLICY_URL: string = 'https://gigbase.jp/personal'

// ヘルプページ
export const HELP_URL: string = 'https://plus.gigbase.jp/category/company-help/'

// 契約内容確認
export const USAGE_PLAN_INFO_URL: string =
  'https://plus.gigbase.jp/company/company-help/2480/#contract'
